<template>
    <Splide class="" :options="options">
        <SplideSlide
            v-for="item in items" :key="item.subtitle_heading"
        >
            <h1 class="text-light text-xl lg:text-4xl uppercase tracking-wide" v-if="item.subtitle_heading">{{ item.subtitle_heading }}</h1>
              
            <p class="text-light text-4xl lg:text-8xl font-florensa uppercase" v-if="item.subtitle_text">{{ item.subtitle_text }}</p>
        </SplideSlide>
    </Splide>
</template>
<script>
import { defineComponent } from "vue"
import { Splide, SplideSlide } from '@splidejs/vue-splide';

export default defineComponent({
    components: {
        Splide,
        SplideSlide,
    },
    created() {
        // console.log(this.items)
    },
    computed: {
        items() {
            return window?.capes?.hero_text_carousel ?? []
        },
    },
    data() {
        return {
            options: {
                pagination: false,
                autoplay: true,
                interval: 3000,
                arrows: false,
                rewind: true,
                speed: 0,
                type : 'slide',
                perMove: 1,
            },
        }
    },
})
</script>
